module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "md-mask"
  }, [_c('div', {
    staticClass: "md-container"
  }, [_c('div', {
    staticClass: "md-dialog-header"
  }, [_c('div', {
    staticClass: "md-header-content"
  }, [_c('div', {
    staticClass: "icon-pill"
  }, [_c('svg', {
    staticStyle: {
      "width": "16px",
      "height": "16px"
    },
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 3H2l8 9.46V19l4 2v-8.54L22 3z"
    }
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('button', {
    staticClass: "md-close-btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "md-dialog-body"
  }, [_c('div', {
    staticClass: "md-setting-row"
  }, [_vm._m(1), _vm._v(" "), _c('lv-toggle', {
    attrs: {
      "value": _vm.enabled
    },
    on: {
      "input": _vm.updateValue,
      "change": _vm.updateValue
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "md-dialog-footer"
  }, [_c('button', {
    staticClass: "md-ghost-btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "md-primary-btn",
    on: {
      "click": _vm.applyFilter
    }
  }, [_vm._v("Apply Filter")])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Filter Runners")]), _vm._v(" "), _c('p', {
    staticClass: "md-subtitle"
  }, [_vm._v("Refine the displayed list of runners")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "md-label"
  }, [_vm._v("Feedback Widget Enabled")]), _vm._v(" "), _c('div', {
    staticClass: "md-desc"
  }, [_vm._v("Show only runners explicitly enabled for telemetry and feedback.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59722406"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/BugseeFilterModal.vue
// module id = 1711
// module chunks = 2